module.exports = __webpack_public_path__ + "img/right-div.3ab7c07b.jpg";